import { FC } from 'react'
import { useIntl } from 'react-intl'

import { useUsersProfilAddressOfResidence } from 'services/profile/profile.hooks'

import UserDetailsAddressForm from './UserDetailsAddressForm'

interface UserDetailsAddresseProps {
  onBack: () => void
}

const UserDetailsAddress: FC<UserDetailsAddresseProps> = ({ onBack }) => {
  const { formatMessage } = useIntl()
  const { usersProfilAddressOfResidence, usersProfilAddressOfResidenceUpdate } =
    useUsersProfilAddressOfResidence()

  return (
    <UserDetailsAddressForm
      onBack={onBack}
      title={formatMessage({ id: 'userDetails.address', defaultMessage: 'Adres zamieszkania' })}
      subtitle={formatMessage({
        id: 'userDetails.addressHint',
        defaultMessage: 'Uzupełnij dane adresowe przypisane do Twojego konta.'
      })}
      address={usersProfilAddressOfResidence}
      onSave={(values) => usersProfilAddressOfResidenceUpdate.mutateAsync(values)}
    />
  )
}

export default UserDetailsAddress
